import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TabContainer, TabPanel, Tab } from 'yankees-react-utils';

const StateTabs = ({ tabs, alignRight }) => {
    const [activeTab, setActiveTab] = useState(tabs[0]);
    return (
        <>
            <TabContainer align={alignRight ? 'right' : undefined}>
                {tabs.map((t) => {
                    const isActive = activeTab.key === t.key;
                    return <Tab key={t.key} active={isActive} onClick={isActive ? undefined : () => setActiveTab(t)}>{t.title}</Tab>;
                })}
            </TabContainer>
            <TabPanel>
                {activeTab.component}
            </TabPanel>
        </>
    );
};

StateTabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        title: PropTypes.string.isRequired,
        component: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.node]).isRequired,
    })).isRequired,
    alignRight: PropTypes.bool,
};
StateTabs.defaultProps = {
    alignRight: false,
};

export default StateTabs;
